import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled } from 'styled-components';
import Icons from '../../Elements/Icons';
import { Media } from '../../theme/Media';
import { Container } from '../../V2/Components/Container';
import Checkbox from './Checkbox';
import { DateFields } from './DateFields';
import Search from './Search';
import Select from './Select';
const Back = styled(Icons.Angle) `
  position: absolute;
  right: 100%;
  transform: rotateZ(90deg);
  top: 0;
  bottom: 0;
  margin: auto;
  cursor: pointer;
  @media ${Media.smMin} {
    right: calc(100% + 5px);
  }
`;
const FiltersGroup = styled.div `
  min-width: 100%;
  display: flex;
  margin-top: 10px;
  margin-bottom: -20px;
  flex-wrap: wrap;
  justify-content: flex-start;
  position: relative;
  z-index: 3;
  @media ${Media.smMin} {
    align-items: center;
  }
  > * {
    margin-bottom: 10px;
    @media ${Media.smMin} {
      max-width: 290px;
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
  @media ${Media.xsMax} {
    flex-direction: column;
  }
`;
const FlexibleFiltersGroup = styled.div `
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 10px 0 -20px;
  position: relative;
  z-index: 3;
  > * {
    min-width: 220px;
    margin: 0 10px 10px 0;
    @media ${Media.xsMax} {
      width: 100%;
      margin-right: 0;
    }
  }
`;
const Actions = styled.div `
  position: relative;
  z-index: 3;
`;
export const Title = styled.div `
  font-size: 22px;
  line-height: 26px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black_1};
  position: relative;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
const Content = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 94px;
  padding: 20px 0 25px;
  @media ${Media.smMin} {
    justify-content: space-between;
  }
  @media ${Media.xsMax} {
    flex-direction: column;
    justify-content: center;
    padding: 20px 0;
    > * {
      width: 100%;
      text-align: center;
    }
    > *:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;
const Wrapper = styled.div `
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
  margin-bottom: 15px;
  min-height: 95px;
`;
const PageHeader = ({ dataTestId, children, className, title, actions, onBackClick, fluid = false, flexibleFiltersGroup, externalFiltersGroup = false, }) => (_jsx(Wrapper, { className: className, children: _jsx(Container, { fluid: fluid, children: _jsxs(Content, { children: [_jsxs(Title, { children: [onBackClick && _jsx(Back, { size: 16, onClick: () => onBackClick() }), title] }), _jsx(Actions, { children: actions }), flexibleFiltersGroup && !externalFiltersGroup && _jsx(FlexibleFiltersGroup, { children: children }), !flexibleFiltersGroup && !externalFiltersGroup && React.Children.map(children, (c) => c)?.some((c) => !!c) && (_jsx(FiltersGroup, { "data-testid": dataTestId, children: children })), externalFiltersGroup && !flexibleFiltersGroup && children] }) }) }));
const PageHeaderMemo = React.memo(PageHeader);
const PageHeaderWrapper = (props) => _jsx(PageHeaderMemo, { ...props });
PageHeaderWrapper.Select = Select;
PageHeaderWrapper.Search = Search;
PageHeaderWrapper.Checkbox = Checkbox;
PageHeaderWrapper.DateFields = DateFields;
PageHeaderWrapper.FiltersGroup = FiltersGroup;
export default PageHeaderWrapper;
